import React, { useState, useEffect } from "react";
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import UserMaster from './UserMaster';
import "./SystemUserDashboard.css"
import OutlateMaster from "./OutlateMaster";
import RestaurentMster from "./RestaurentMster";
import AddOutletToUser from "./AddOutletToUser";
import LiveTableStatusSystemUser from "./LiveTableStatusSystemUser";
import DeleteUserData from "./DeleteUserData";
import AccountHeadMaster from "./AccountHeadMaster";
import StatusDayEndPerform from "./StatusDayEndPerform";

const SystemUserDashboard = () => {
  const [selectedLabel, setSelectedLabel] = useState("UserMaster");
  const location = useLocation();
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  // Define the button routes here
  const SystemUserButton = [
    { label: "Rest Master", path: "/RestaurentMaster" },
    { label: "Outlate Master", path: "/OutlateMaster" },
    { label: "UserMaster", path: "/UserMaster" },
    { label: "AddOutletToUser", path: "/AddOutletToUser" },
    { label: "LiveTable Status", path: "/SystemUserLiveTableStatus" },
    { label: "Delete UserData", path: "/deleteUserData" },
    { label: "Accounts Master", path: "/AccountHeadMaster" },
    { label: "Status DayEnd", path: "/StatusDayEndPerform" },
 
  
    // You can add more buttons for other pages like SwiggyNewOrder, etc.
  ];

  useEffect(() => {
    const currentPathSegment = location.pathname.split("/").pop();
    // Update selected label based on current path
    const currentButton = SystemUserButton.find(
      (button) => button.path.replace("/", "") === currentPathSegment
    );
    if (currentButton) {
      setSelectedLabel(currentButton.label);
    }
  }, [location.pathname]); // Re-run on pathname change

  const handleButtonClick = () => setSidebarVisible(false);
  const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);

  return (
    <>
      {/* Navbar */}
      <nav className="navbar shadow p-3 bg-body rounded navbar-light bg-light d-flex align-items-center">
        <span className="navbar-brand mb-0 h1">
          <i>BillTrace</i> System User
        </span>
        {/* <h5 className="selected-label ">{selectedLabel}</h5> */}
        {isSidebarVisible ? (
          <IoClose
            className="sidebar-toggle-icon ms-auto"
            onClick={toggleSidebar}
          />
        ) : (
          <IoMenu
            className="sidebar-toggle-icon ms-auto"
            onClick={toggleSidebar}
          />
        )}
      </nav>

      {/* Sidebar & Main Content */}
      <div className="d-flex">
        {/* Sidebar */}
        <div className={`sidebar ${isSidebarVisible ? "open" : ""}`}>
          <div className="button-container mt-2">
            {SystemUserButton.map((button, index) => (
              <Link
                key={index}
                to={`/SystemUserDashboard${button.path}`} // Absolute path within the dashboard
                className="btn btn-primary mb-2 MasterCreationButtons"
                onClick={handleButtonClick}
              >
                {button.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <Routes>
            {/* Redirect to /SystemUserDashboard/UserMaster if no route matches */}
            <Route path="/" element={<Navigate to="/SystemUserDashboard/UserMaster" replace />} />
            {/* Add the routes for each page inside the dashboard */}
            <Route path="/UserMaster" element={<UserMaster />} />
            <Route path="/OutlateMaster" element={<OutlateMaster />} />
            <Route path="/SystemUserLiveTableStatus" element={<LiveTableStatusSystemUser />} />
            <Route path="/deleteUserData" element={<DeleteUserData />} />

            <Route path="/RestaurentMaster" element={<RestaurentMster />} />
            <Route path="/AddOutletToUser" element={<AddOutletToUser />} />
            <Route path="/AccountHeadMaster" element={<AccountHeadMaster />} />
            <Route path="/StatusDayEndPerform" element={<StatusDayEndPerform />} />
            
            {/* You can add more child routes here */}
          </Routes>
        </div>
      </div>
    </>
  );
};

export default SystemUserDashboard;
